<template>
	<div class="row contentblock" data-aos="fade-in" data-aos-duration="1500" data-aos-once="true">
		<div class="columns column6 image-block">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
			<!--<div class="contentblock-bg" /> -->
		</div>
		<div class="columns column6 text-block">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	padding: 0;
	margin: 20px auto;

	.image-block {
		padding: 30px;
		position: relative;
	}

	.text-block {
		padding: 60px 0 10px;
	}

	&:nth-child(odd) {
		flex-direction: row-reverse;

		.text-block {
			padding: 10px 0 60px;
		}

		.image-block {
			border-right: $secondary-background-color;
			border-right-style: solid;
			border-width: 1px;
		}
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
		position: relative;
		z-index: 2;
	}

	.contentblock-bg {
		display: block;
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
		inset: 0;
		background:
			url('~/assets/images/contentblock-bg-top.png') top center no-repeat,
			url('~/assets/images/contentblock-bg-bottom.png') bottom center no-repeat;
		background-color: #091427;
	}

	.contentblock-content {
		padding: 50px;
		background: $primary-background-color;
	}
}

@media (max-width: 1080px) {
	.contentblock {
		.column6 {
			width: 100%;
		}

		.contentblock-bg {
			background:
				url('~/assets/images/contentblock-bg-top.png') top center no-repeat,
				url('~/assets/images/contentblock-bg-bottom-white.png') bottom center no-repeat;
			background-color: #091427;
		}

		.text-block {
			padding: 0 0 20px !important;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		.contentblock-content {
			padding-left: 20px;
			padding-right: 20px;
		}
	}
}
</style>
